// Always shown in Europe/Istanbul on the 24-hour clock, whatever the device's zone (UI architecture
// §11). The API sends RFC 3339 UTC, so a string always parses to its instant.
const istanbul = { timeZone: 'Europe/Istanbul', hourCycle: 'h23' } as const;
const day = { day: 'numeric', month: 'short', year: 'numeric' } as const;
const clock = { hour: '2-digit', minute: '2-digit' } as const;

const dateTimeFormat = new Intl.DateTimeFormat('tr-TR', { ...istanbul, ...day, ...clock });
const dateFormat = new Intl.DateTimeFormat('tr-TR', { ...istanbul, ...day });
const timeFormat = new Intl.DateTimeFormat('tr-TR', { ...istanbul, ...clock });

// '25 Eyl 2026 14:30'
export function formatDateTime(value: string | Date): string {
  return dateTimeFormat.format(new Date(value));
}

// '25 Eyl 2026'
export function formatDate(value: string | Date): string {
  return dateFormat.format(new Date(value));
}

// '14:30'
export function formatTime(value: string | Date): string {
  return timeFormat.format(new Date(value));
}
